import React from "react";

const C = {
  surface2:"#202020", border:"#2a2a2a", white:"#fff",
  orange:"#FF5F1F", magenta:"#E8197D",
};

const inp = (x={}) => ({ background:C.surface2, border:`0.5px solid ${C.border}`, borderRadius:8, padding:"9px 12px", color:C.white, fontSize:13, outline:"none", width:"100%", boxSizing:"border-box", ...x });

export function TravelEditor({ value, onChange }) {
  return (
    <textarea
      style={inp({minHeight:100,resize:"vertical"})}
      value={value}
      onChange={e=>onChange(e.target.value)}
      placeholder="Flytider, busstider, møtested, referansenummer..."/>
  );
}